var _rect, _circle, _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgImagesDefaultDark = function SvgImagesDefaultDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 30,
    height: 30,
    rx: 7.533,
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 11,
    r: 2,
    stroke: "#fff",
    strokeOpacity: 0.8,
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "Images_Default_Dark_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.97 18c-.77-1.333-2.695-1.333-3.464 0l-2.48 4.295-1.29-2.256c-.767-1.344-2.705-1.344-3.473 0L9.71 28.008C8.948 29.34 9.91 31 11.446 31h17.565c1.54 0 2.502-1.667 1.732-3L24.97 18z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.506 18l1.732 1-1.732-1zm3.464 0l-1.732 1 1.732-1zm-5.944 4.295l-1.737.992 1.728 3.024 1.74-3.016-1.731-1zm-1.29-2.256L16 21.03l1.736-.992zm-3.473 0L16 21.03l-1.736-.992zM9.71 28.008l1.736.992-1.736-.992zM17.464 31v2-2zm3.09 0v-2 2zm8.457 0v2-2zm1.732-3l1.732-1-1.732 1zm-7.505-9l3.464-2c-1.54-2.667-5.389-2.667-6.929 0l3.465 2zm-2.48 4.295L23.238 19l-3.465-2-2.48 4.295 3.465 2zM16 21.031l1.29 2.256 3.472-1.984-1.29-2.256L16 21.03zm0 0l3.473-1.984c-1.536-2.688-5.41-2.688-6.946 0L16 21.03zM11.446 29L16 21.031l-3.473-1.984-4.554 7.968L11.446 29zm0 0l-3.473-1.985C6.45 29.682 8.375 33 11.446 33v-4zm6.016 0h-6.016v4h6.016v-4zm.002 0h-.002v4h.002v-4zm3.09 0h-3.09v4h3.09v-4zm8.457 0h-8.457v4h8.457v-4zm0 0v4c3.08 0 5.004-3.333 3.464-6l-3.464 2zm-5.773-10l5.773 10 3.464-2-5.773-10-3.464 2z",
    fill: "#fff",
    fillOpacity: 0.8,
    mask: "url(#Images_Default_Dark_svg__a)"
  })));
};
export default SvgImagesDefaultDark;